import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './Renderer_Order.scss';
import { Loader_OrderButton } from './Loader_OrderButton.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
export class Renderer_Order extends ComponentSync {
    onContextMenu;
    getVariant = () => undefined;
    getDisabled = () => undefined;
    getOrderClass() {
        return 'protocol__order';
    }
    render() {
        const className = this.getOrderClass();
        const Icon = this.getOrderIcon?.();
        const orderLabel = this.getOrderLabel();
        const readonly = ModuleFE_EMInterface.isReadonly();
        return _jsxs(Button, { className: className, disabled: this.getDisabled() || readonly, variant: this.getVariant(), onClick: this.onOrderClick, onContextMenu: this.onContextMenu, loader: Loader_OrderButton, children: [Icon && _jsx(Icon.component, {}), _jsx("div", { className: 'protocol__order__label', children: orderLabel })] });
    }
}
//# sourceMappingURL=Renderer_Order.js.map